// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ucvbrjkvknnczkmtjvmt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVjdmJyamt2a25uY3prbXRqdm10Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIxNjE3NzMsImV4cCI6MjA2NzczNzc3M30.XCQfVAkT1easTAtXkdzmnLlJHXa8-HfWytSI88AOtZ0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});